import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../../../Services/DataSharingService';
import { Subscription } from 'rxjs/Subscription';
import { HeaderService } from '../../../../Services/HeaderService';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-basic-checkbox-default',
	templateUrl: './basic-checkbox-default.component.html',
	styleUrls: ['./basic-checkbox-default.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class BasicCheckboxDefaultComponent implements OnInit {

	@ViewChild('container', { read: ElementRef }) container: ElementRef;

	private subscription: Subscription[] = [];
	public data: string = '';
	public showCode = '';

	constructor(private _dataService: DataService, private cdRef: ChangeDetectorRef, private _headerService: HeaderService, private _titleService: Title) {
		_titleService.setTitle('Check box');
		this._dataService.GetCode().subscribe(data => {
			this.data = data;
		})
		_dataService.showCode.subscribe(value => {
			this.showCode = value;
		})
	}

	ngOnInit() {

		this._dataService.SetCode(this.container.nativeElement.innerHTML);
	}

	ngOnDestroy(): void {
		this.subscription.map(subscription => {
			subscription.unsubscribe();
		})
	}

	ShowCode(event) {
		this.data = this.container.nativeElement.innerHTML;
		if (this.showCode == 'basic-checkbox-default') {
			this._dataService.setState('');
		} else {
			this._dataService.setState('basic-checkbox-default');
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/features/pretty-check/basic-checkbox-default/basic-checkbox-default.component.ts